import logger from '%app/js/common/services/Logger';
import isUndefinedResponse from '../isUndefinedResponse';

export default class UndefinedErrorResponseMiddleware {
    constructor(storageService) {
        this.storageService = storageService;
    }

    onResponseError(error) {
        if (isUndefinedResponse(error)) {
            logger.warning('Undefined error response', { ...error });
            window.location.reload();
            // eslint-disable-next-line no-param-reassign
            error.mute = true;
        }

        if (this.storageService) {
            const { status, statusText } = error.response || {};

            this.storageService.dispatchStorageEvent('httpClientError', {
                status,
                statusText,
                message: error.message,
            });
        }

        return Promise.reject(error);
    }
}
